"use strict";
class ScriptSubscriber {
}
exports.ScriptSubscriber = ScriptSubscriber;
